import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import ProfileAmendmentRequestsDataTable from '../../../modules/admin/components/ProfileAmendmentRequest/ProfileAmendmentRequestsDataTable';

const ProfileAmendmentRequests = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>ProfileAmendmentRequests.ProfileAmendmentRequests')} />
      <ProfileAmendmentRequestsDataTable />
    </>
  );
};

export default ProfileAmendmentRequests;
